import { Table, Box } from '@nimbus-ds/components';
import { ProductTransferDetailsResponseDto } from '@tiendanube/common';

type ProductVariant =
  ProductTransferDetailsResponseDto['productVariants'][number];

interface TransferVariantCellProps {
  productId: string;
  productVariants: ProductVariant[];
  renderProp: (variant: ProductVariant) => React.ReactNode;
}

function TransferVariantCell({
  productId,
  productVariants,
  renderProp,
}: Readonly<TransferVariantCellProps>) {
  const variants = productVariants.filter(
    (variant) => variant.productId === productId,
  );

  if (variants.length === 0) {
    return null;
  }

  return (
    <Table.Cell>
      <Box display="flex" flexDirection="column" gap="2" paddingRight="3">
        {variants.map((variant) => (
          <Box
            key={variant.variantName}
            display="flex"
            alignItems="center"
            flexGrow="1"
            height="34px"
          >
            {renderProp(variant)}
          </Box>
        ))}
      </Box>
    </Table.Cell>
  );
}

export default TransferVariantCell;
